module.exports = __webpack_public_path__ + "media/greed.308432a1.mp4";